import React, { useState, useRef, useCallback, useLayoutEffect, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import People from '@src/pc/index/layout/Page1/People';
import Chip from 'Chip';

const Page1 = (props) => {
    const [starAnimation, setStarAnimation] = useState(false);
    const [startFirstSlide, setStartFirstSlide] = useState(false);
    const [isLoadVideo, setIsLoadVideo] = useState(false);
    const videoRef = useRef(null);
    const logoRef = useRef(null);
    const videoUrl = 'https://x0.ifengimg.com/fe/custom/2025_06_12/p1.3cb01dd6d937.mp4';
    const { peopleList, leaderVideo, onChangeMaskVisible, onChangeCurrentVideo, onChangeFloat, config, peopleIndex, onChangePeopleIndex, guestData } = props;
    const [isShowHUD, setIsShowHUD] = useState(false);

    const swiperRef = useRef();

    const changePeopleAndSwiper = (index) => {
        onChangePeopleIndex(index);
    };

    useLayoutEffect(() => {
        // eslint-disable-next-line no-unused-expressions
        swiperRef.current?.slideTo(peopleIndex + 1);
    }, [peopleIndex]);

    useEffect(() => {
        const videoElement = document.createElement('video');
        let videoPlayNum = 0;

        videoElement.src = videoUrl;

        if (videoElement.onloadedmetadata) {
            videoElement.addEventListener('loadedmetadata', () => {
                setIsLoadVideo(true);

                setTimeout(() => {
                    setIsShowHUD(true);
                    onChangeFloat(true);
                }, 3500);
            });
        } else {
            videoElement.addEventListener('loadstart', () => {
                setTimeout(() => {
                    setIsLoadVideo(true);

                    setTimeout(() => {
                        setIsShowHUD(true);
                        onChangeFloat(true);
                    }, 3500);
                }, 1000);
            });
        }

        const videoDom = videoRef.current;
        const logoDom = logoRef.current;

        logoDom.addEventListener('animationend', () => {
            videoDom.play();
            setStarAnimation(true);
        });
        videoDom.addEventListener('timeupdate', () => {
            if (videoDom.currentTime > 8) {
                videoPlayNum++;
                if (videoPlayNum === 1) {
                    setStartFirstSlide(true);
                }
            }
        });

        videoDom.addEventListener('ended', () => {
            videoDom.currentTime = 9;

            videoDom.play();
        });
    }, []);

    useEffect(() => {
        if (startFirstSlide && peopleIndex === -1) {
            changePeopleAndSwiper(0);
            setStartFirstSlide(false);
        }
        if (startFirstSlide) {
            setStartFirstSlide(false);
        }
    }, [startFirstSlide, peopleIndex]);

    const toPrev = () => {
        changePeopleAndSwiper(peopleIndex - 1);
    };

    const toNext = () => {
        if (peopleIndex < peopleList.length - 1) {
            changePeopleAndSwiper(peopleIndex + 1);
        }
    };

    const openVideo = () => {
        onChangeCurrentVideo({
            url: leaderVideo.videoUrl,
            guid: leaderVideo.videoGuid,
            duration: leaderVideo.videoDuration,
        });
        onChangeMaskVisible(true);
    };

    return (
        <div className={Style.page1}>
            {peopleIndex === -1 && <img className={`${Style.logo} ${isShowHUD ? Style.show : ''}`} src={require('@src/common/assets/logo.png')} alt="" />}
            {config.find((a) => a.id === 'peopleList').isShow && (
                <div className={`${Style.peopleList} ${isShowHUD ? Style.show : ''} ${peopleIndex < 0 ? '' : Style.inPeople}`}>
                    <div className={Style.first}>
                        <div className={`${Style.people} ${-1 === peopleIndex ? Style.active : ''}`} onClick={() => changePeopleAndSwiper(-1)}>
                            首页
                        </div>
                        <span className={Style.divider}>/</span>
                    </div>
                    {peopleList.map((people, index) => {
                        return (
                            <div key={index}>
                                <div className={`${Style.people} ${index === peopleIndex ? Style.active : ''}`} onClick={() => changePeopleAndSwiper(index)}>
                                    {people.name}
                                </div>
                                {index < peopleList.length - 1 && <span className={Style.divider}>/</span>}
                            </div>
                        );
                    })}
                </div>
            )}
            <Swiper
                modules={[Navigation, Mousewheel, Keyboard]}
                className={Style.swiper}
                speed={1500}
                mousewheel={{
                    forceToAxis: true,
                }}
                keyboard={{
                    enabled: true,
                }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onSlideChange={(swiper) => onChangePeopleIndex(swiper.realIndex - 1)}>
                <SwiperSlide>
                    <div style={{ position: 'relative', height: '100%' }}>
                        <div className={`${Style.bannerBox} ${isLoadVideo ? Style.bannerShow : ''}`} ref={logoRef}>
                            <img className={`${Style.bannerPic}`} src="https://x0.ifengimg.com/ucms/2025_21/29CD075125629CC8A2E99EAA7B0D2C4B56CB7B89_size48_w489_h500.png" />
                            <img
                                className={`${Style.bannerStarBottom}  ${starAnimation ? Style.opacityAnimi : ''}`}
                                src="https://x0.ifengimg.com/ucms/2025_21/3EFE75A60B7408611CB8EAD82A8FE86658424E09_size42_w446_h221.png"
                            />
                            {/* <img className={`${Style.bannerStar} ${starAnimation ? Style.bannerShow : ''}`} src="https://x2.ifengimg.com/fe/custom/junpintan2022/light.030aecac.png" /> */}
                            <img
                                className={`${Style.bannerStar}  ${starAnimation ? Style.opacityAnimi : ''}`}
                                src="https://x0.ifengimg.com/ucms/2025_21/0168B0DDAD8AA622CFCDBBDFD33FF9A0B365D1E0_size21_w455_h191.png"
                            />
                        </div>
                        <video muted={true} className={Style.bannerVideo} controls={false} preload="auto" ref={videoRef} src={videoUrl} />
                        <div className={`${Style.playWp} ${isShowHUD ? Style.show : ''}`} onClick={openVideo}>
                            {leaderVideo?.videoUrl && (
                                <div className={Style.play}>
                                    <img className={Style.play} src="https://x0.ifengimg.com/ucms/2025_21/ED11FCC5C2373547D571298B9EC9489A904EF5F4_size2_w63_h63.png" alt="" />
                                    <span>先导片</span>
                                </div>
                            )}
                        </div>
                    </div>
                </SwiperSlide>
                {config.find((a) => a.id === 'peopleList').isShow &&
                    peopleList.map((people, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <People people={people} guestData={guestData} onChangeMaskVisible={onChangeMaskVisible} onChangeCurrentVideo={onChangeCurrentVideo} index={index} />
                            </SwiperSlide>
                        );
                    })}
            </Swiper>
            {config.find((a) => a.id === 'peopleList').isShow && isShowHUD && (
                <>
                    <img
                        className={`${Style.navigation} ${Style.prev} ${peopleIndex > -1 ? '' : Style.hide}`}
                        src={require(`@src/common/assets/${peopleIndex > -1 ? 'prev' : 'prev2'}.png`)}
                        alt=""
                        onClick={toPrev}
                    />
                    <img
                        className={`${Style.navigation} ${Style.next} ${peopleIndex === -1 ? Style.animate : ''}`}
                        src={require(`@src/common/assets/${peopleIndex > -1 ? 'next' : 'next2'}.png`)}
                        alt=""
                        onClick={toNext}
                    />
                </>
            )}
        </div>
    );
};

Page1.propTypes = {
    peopleList: PropTypes.array,
    config: PropTypes.array,
    leaderVideo: PropTypes.object,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    onChangeFloat: PropTypes.func,
    peopleIndex: PropTypes.number,
    onChangePeopleIndex: PropTypes.func,
    guestData: PropTypes.array,
};

export default errorBoundary(Page1);
